module.exports = __webpack_public_path__ + "img/banner01.8678d7f5.png";